export { default as ProductPriceDS } from './product-price-ds'
export type { ProductPriceDSProps, ProductPriceDSVariant } from './product-price-ds'
